import { constants, database, http } from 'lib_ui-services';

const _private = { post: http.post, getDatabase: database.get };
export { _private };

export default {
    verb: 'doingNew',
    namespace: 'deploy',
    relation: 'environment',
    type: 'onDemand',
    description: 'Create the next on-demand environment',
    logic
};

/**
 * After confirmation, creates the environment through the server endpoint and
 * synchronizes environment records so the new child appears in One Touch.
 * Progress and success messages keep the user informed while this completes.
 */
async function logic({ data, dispatch }) {
    if (!(await confirmCreation(dispatch))) return data;

    showProgress(dispatch);
    try {
        const { result: environment } = await _private.post('/api/deploy/environment/on-demand', {});
        await _private.getDatabase().synchronization.syncOneRelation({
            namespaceTitle: 'deploy',
            relationTitle: 'environment'
        });
        dispatch(
            {
                message: `${environment.title} was created.`,
                variant: 'success',
                type: constants.notificationTypes.TOAST
            },
            { verb: 'pop', namespace: 'application', relation: 'notification' }
        );
        return { ...data, result: environment };
    } finally {
        hideProgress(dispatch);
    }
}

function confirmCreation(dispatch) {
    return new Promise(resolve => {
        dispatch(
            {
                message:
                    'Add the next on-demand environment and create its DNS records? This won’t deploy anything yet.',
                okButtonText: 'Add environment',
                cancelButtonText: 'Cancel',
                okAction: () => resolve(true),
                cancelAction: () => resolve(false),
                jumpQueue: true
            },
            { verb: 'confirm', namespace: 'application', relation: 'user' }
        );
    });
}

function showProgress(dispatch) {
    dispatch(
        {
            mainTitle: 'Adding environment',
            title: 'Creating environment and DNS records',
            current: 0,
            total: 1
        },
        { verb: 'update', namespace: 'application', relation: 'progress' }
    );
}

function hideProgress(dispatch) {
    dispatch(
        { mainTitle: 'Adding environment' },
        { verb: 'reset', namespace: 'application', relation: 'progress' }
    );
}
